// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAuffSS0a-zpVq1Fr53pAor74E88DMIEYo",
  authDomain: "trailers-a9049.firebaseapp.com",
  projectId: "trailers-a9049",
  storageBucket: "trailers-a9049.firebasestorage.app",
  messagingSenderId: "1020027706624",
  appId: "1:1020027706624:web:309f8f276bc95ab28fe7e5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
// Callable Cloud Functions client. Default region (us-central1) matches where
// our functions are deployed.
export const functions = getFunctions(app);